import React, { Component } from 'react'
import './NavBar.css'
import brandLogo from '../../../public/image/logo_light.svg'

export default class NavBar extends Component {
  render() {
    return (
      <div className='navbar'>
        <img src={brandLogo} alt='Prayogshala Logo' />
        <a href='/project0' className='navbar-link'>
          Project0
        </a>
        <a href='/project1' className='navbar-link'>
          Project1
        </a>
        <a href='/support' className='navbar-link'>
          Support
        </a>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/common/navBar/NavBar.js